import React from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import { Typography } from "@mui/material";
import { cssProperties } from "../utils/commonCssProperties";

import Sidebar from "../layouts/sidebar";
import Header from "../layouts/header";
import Layout from "../layouts/layout";
import PageHeading from "../layouts/pageHeading";
import AdmitCardVerifier from "../components/AdmitCardVerification";

// No "Dashboard" crumb: this page belongs to the Admit Card Verifier role,
// which has no dashboard to go back to.
const AdmitCardVerification = () => {
  const breadcrumbs = [
    <Typography
      key="1"
      color="text.primary"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        color: cssProperties?.fontcolor?.primary,
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: "20px",
        letterSpacing: "0.1px",
      }}
    >
      Admit Card Verification <MdKeyboardArrowDown size={16} />
    </Typography>,
  ];

  return (
    <>
      <Sidebar />
      <Header breadcrumbs={breadcrumbs} />
      <Layout>
        <PageHeading title={"Admit Card Verification"} />
        <AdmitCardVerifier />
      </Layout>
    </>
  );
};

export default AdmitCardVerification;
